import { BHCustomEventPodcastProps } from "@components/Gallery/PodcastGallery";
import PodcastDialog from "@elements/Podcast/PodcastDialog";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
import useSwrApi from "@hooks/useSwrApi";
import { type PodcastProcessedResponse } from "@transformer/usePodcastResponse";
import { useState } from "react";

import MediaCard from "./MediaCard";

export type PodcastPackageProps = {
  bhCustomEventProps: BHCustomEventPodcastProps;
};

export default function PodcastPackage({
  bhCustomEventProps,
}: PodcastPackageProps) {
  const [podcastDialog, setPodcastDialog] = useState({
    visible: false,
    source: "",
  });
  const { data: podcasts } = useSwrApi<PodcastProcessedResponse[]>("podcasts");
  const bhCustomEvents = useBHCustomEventAnalyticsCall();

  const openPodcastDialog = (source?: string) => {
    setPodcastDialog({
      visible: true,
      source: source || "",
    });
    bhCustomEvents(
      bhCustomEventProps.eventCategory,
      bhCustomEventProps.eventAction,
      bhCustomEventProps.eventLabel,
    );
  };

  const closePodcastDialog = (source?: string) => {
    setPodcastDialog({
      visible: false,
      source: source || "",
    });
  };

  return (
    <>
      {podcasts && (
        <>
          <MediaCard<PodcastProcessedResponse>
            variant="Podcasts"
            renderedThumbnail={podcasts.slice(0, 10)}
            handleOnClickCallback={openPodcastDialog}
            moreLink={{
              destination: "podcasts",
            }}
          />
          <PodcastDialog
            podcastDialog={podcastDialog}
            handleOnClickCloseDialog={closePodcastDialog}
          />
        </>
      )}
    </>
  );
}
